import React from "react";
import { deleteMain, getSizes } from "../../api";
import { Await, defer, useLoaderData } from "react-router-dom";
import DataGrid, { image } from "../../Component/DataGrid";
import ActionButton from "../../Component/ActionButton";
import BrandsTagsMadeInTypesModal from "./Modal/BrandsTagsMadeInTypesModal";

export const loader = ({ request }) => {
  const url = new URL(request.url);
  const sort = url.searchParams.get("sort");
  const order = url.searchParams.get("order");
  const search = url.searchParams.get("search");

  const PromisedData = getSizes(sort, order, search, "13");
  return defer({ data: PromisedData });
};

export default function ProductsSize() {
  const data = useLoaderData();
  const [actionData, setActionData] = React.useState({});
  const Actions = (p) => {
    return (
      <div className="d-flex h-100 justify-content-center align-items-center gap-2">
        <ActionButton modal="BTMTModal" setActionData={setActionData} p={p} />

        <ActionButton
          p={p}
          isDelete={true}
          deleteFunc={deleteMain}
          deletePaymentType="13"
        />
      </div>
    );
  };
  const [colDefs, setColDefs] = React.useState([
    {
      field: "attachment",
      cellRenderer: image,
    },

    {
      field: "kuName",
      headerName: "Kurdish Name",
    },
    {
      field: "arName",
      headerName: "Arabic Name",
    },

    {
      field: "actions",
      cellRenderer: Actions,
    },
  ]);
  return (
    <section className="p-3">
      <React.Suspense
        fallback={
          <div className="w-100 h-screen d-flex justify-content-center align-items-center">
            <span className="loader-admin">Loading</span>
          </div>
        }
      >
        <Await resolve={data.data}>
          {(data) => {
            return (
              <DataGrid
                modalType={"BTMTModal"}
                setActionData={setActionData}
                hasCreate={true}
                rowHeight={80}
                data={data}
                col={colDefs}
              />
            );
          }}
        </Await>
      </React.Suspense>

      <BrandsTagsMadeInTypesModal actionData={actionData} type="13" />
    </section>
  );
}
